window.H_H = 0;